// extracted by mini-css-extract-plugin
module.exports = {"sociallink":"social-link-module--sociallink--1W9hT","sociallink__icon":"social-link-module--sociallink__icon--FZ7Zi"};